// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`<SquareRadioButtons /> renders without crashing 1`] = `
<Fragment>
  <div
    className="squareRadioButtons vertical"
  >
    <span
      className="radio"
      key="test_0"
    >
      <input
        className="radioInput"
        id="test_0"
        name="test"
        onChange={[Function]}
        type="radio"
        value="Item 1"
      />
      <label
        className="radioLabel"
        htmlFor="test_0"
      >
        <div
          className="labelMain"
        >
          Item 1
        </div>
      </label>
    </span>
    <span
      className="radio"
      key="test_1"
    >
      <input
        className="radioInput"
        id="test_1"
        name="test"
        onChange={[Function]}
        type="radio"
        value="Item 2"
      />
      <label
        className="radioLabel"
        htmlFor="test_1"
      >
        <div
          className="labelMain"
        >
          Item 2
        </div>
      </label>
    </span>
    <span
      className="radio"
      key="test_2"
    >
      <input
        className="radioInput"
        id="test_2"
        name="test"
        onChange={[Function]}
        type="radio"
        value="Item 3"
      />
      <label
        className="radioLabel"
        htmlFor="test_2"
      >
        <div
          className="labelMain"
        >
          Item 3
        </div>
      </label>
    </span>
  </div>
</Fragment>
`;
